import React, { useCallback, useEffect } from "react";
import debounce from "lodash.debounce";
import { withPrefix } from "gatsby";

import { getResults } from "../../../services/predictive";
import { getFilteredResults } from "../../../services/filter";

function filterTranslate(word: string) {
  switch (word) {
    case "Libros físicos":
      return ["book physical", "books"];
    case "Libros digitales":
      return ["book digital", "books"];
    case "Artículos":
      return ["artículo", "articles"];
    case "Películas":
      return ["film", "movies"];
    case "Revistas":
      return ["journal", "journals"];
    case "Revistas físicas":
      return ["journal physical", "journals"];
    case "Revistas digitales":
      return ["journal digital", "journals"];
    case "Series":
      return ["series", "series"];
    default:
      return word;
  }
}

export default function SearcherInput({
  isBrowser,
  searchWord,
  type,
  defaultPlaceholder,
  dynamicPlaceholder,
  setActiveSelect,
  setSearchWord,
  setResults,
  filterSelected,
  handleKeyDown,
  autoFocus,
}) {

  const renderInput = () => {

    useEffect(() => {
      delayedButtonChange()
    }, [filterSelected]) 

    const delayedInputChange = useCallback(
      debounce(async (text: string) => {
        if (text.length > 2 && filterSelected?.length) {
          if (filterSelected.includes("Todos")) {
            const data = await getResults(text, 10);
            setResults(data.data.data);
          } else {
            let contentTypes = "";
            filterSelected.map((filter, index) => (
              contentTypes += index === 0 ? filterTranslate(filter) : `&contentType=${filterTranslate(filter)}`)
            );
            const data = await getFilteredResults(
              text,
              contentTypes,
              "10"
            );
            setResults(
              data?.data.data.filter || []
            );
          }
        } else {
          setResults([]);
        }
      }, 500),
      [filterSelected]
    );    

    const delayedButtonChange = async () => {
      if (searchWord.length > 2 && filterSelected?.length) {
        if (filterSelected.includes("Todos")) {
          const data = await getResults(searchWord, 10);
          setResults(data.data.data);
        } else {
          let contentTypes = "";
          filterSelected.map((filter, index) => (
            contentTypes += index === 0 ? filterTranslate(filter) : `&contentType=${filterTranslate(filter)}`)
          );
          const data = await getFilteredResults(
            searchWord,
            contentTypes,
            "10"
          );
          setResults(
            data?.data.data.filter || []
          );
        }
      } else {
        setResults([]);
      }
    }

    const onInputChange = (e) => {
      setSearchWord(e.currentTarget.value || searchWord);
      delayedInputChange(e.currentTarget.value || searchWord);
    };

    const onInputFocus = (e) => {
      setSearchWord(e.currentTarget.value || searchWord);
    }

    return (
      <div className="m-searcher-container__input">
        <i
          className="icon icon-search"
          onClick={() => {
            let contentTypes = "";
            filterSelected.map(filter => contentTypes += `&contentType=${filter}`);
            isBrowser &&
            searchWord.trim().length > 2 &&
            window.location.assign(
              withPrefix(`/resultados-busqueda/?search=${searchWord}${contentTypes}`)
            )
          }}
        />
        <input
          autoFocus = {autoFocus}
          defaultValue={defaultPlaceholder}
          placeholder={
            type === "preguntas"
              ? "¿Qué estás buscando?" : type ==="biblioteca" ? "Buscar por reseñas, autores o entrevistas" : type === "global" ?  dynamicPlaceholder : defaultPlaceholder 
          }
          onClickCapture={() => setActiveSelect(true)}
          onChange={onInputChange}
          onFocus={onInputFocus}
          onKeyDown={handleKeyDown}
          id="inputSearch"
        />
        {searchWord.trim().length > 2 && (
          <i
            className="icon icon-times-circle1"
            onClickCapture={() => {
              setSearchWord("");
              setResults([]);
            }}
          />
        )}
      </div>
    );
  };

  return renderInput();
}
